// src/components/Footer.js

import styles from "../styles/App.module.css";

function Footer() {
  return (
    <footer className={styles.siteFooter}>
      <p>&copy; 2024 LDCounselling - All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
